/**
 * O ÚNICO loader de tela cheia do app autenticado.
 *
 * Montado uma vez na raiz; abre quando o loadingStore tem qualquer chave
 * viva e fecha (fade 320ms) quando a última solta. Como é sempre a MESMA
 * instância do BrandLoader fullscreen, a transição auth → projeto → cena
 * é um loader só segurando a tela — troca a legenda, não o loader.
 */
import { motion, AnimatePresence } from 'framer-motion';
import { BrandLoader } from '@/components/ui/BrandLoader';
import { useLoadingStore } from '@/store/loadingStore';

export function GlobalLoadingGate() {
  const keys = useLoadingStore((s) => s.keys);
  const open = keys.length > 0;

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          key="global-loading-gate"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.32, ease: [0.32, 0.72, 0, 1] }}
          className="fixed inset-0 z-[9000]"
        >
          {/* Sem legendas: a identidade de loading é só a porcentagem. */}
          <BrandLoader variant="loading" />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
